export enum DemographicsColor {
  Male = '#c1e0fc',
  Female = '#b09bbe',
  Age16_24 = '#a4e3a4',
  Age25_44 = '#fae1b4',
  Age45_plus = '#f4b6bb',
}
